import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { TwitterTweetButtonInterface } from 'common/types/entities/TwitterTweetButtonInterface'
import React from 'react'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import Input from '../components/Input/Input'
import { useUpdateProp } from '../hooks/useUpdateProps'
import DeviceAppearanceNew from '../options/DeviceAppearance/DeviceAppearanceNew'
import { FlexAlignStyle } from '../styles'
import { SettingsProps } from '.'

function TwitterTweetButtonSettings({
  entity,
  defaultEntity,
}: SettingsProps<TwitterTweetButtonInterface>) {
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)
  return (
    <React.Fragment>
      <Input
        label="entity_settings.twitter_tweet_button.text.label"
        value={entity.text}
        update={updateProp('text')}
      />
      <FlexAlignStyle
        align={entity.alignSelf}
        mobileAlign={entity.mobileAlignSelf || entity.alignSelf}
        mobileUpdate={updateProp('mobileAlignSelf')}
        update={updateProp('alignSelf')}
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
    </React.Fragment>
  )
}

export default TwitterTweetButtonSettings
